import React, { useEffect, useState } from "react"
import { Container, Row, Col, Card, Modal, Button } from "react-bootstrap"
import "./dashboard.css"
import { useNavigate } from "react-router-dom"
import {
  roomsApi,
  useAddToFavRoomMutation,
  useDeleteRoomMutation,
  useGetRoomsQuery,
  useUpdateRoomNameMutation,
} from "../../services/roomsServices"
import { toast } from "react-toastify"
import RoomCard from "../roomCard/roomCards"
import { LuClipboardEdit } from "react-icons/lu"
import { AiOutlineHeart, AiOutlinePlusCircle } from "react-icons/ai"
import { BsTrash } from "react-icons/bs"
import { useAppDispatch, useAppSelector } from "../../app/hooks"
import noData from "../../img/nodata.jpg"
import Loader from "react-js-loader"
import {
  favRoom,
  roomStates,
  roomsListArray,
} from "../../services/slices/rooms"
import { clamp } from "lodash"

const Dashboard = () => {
  const navigate = useNavigate()

  const dispatch = useAppDispatch()

  const { searchRooms } = useAppSelector(roomStates)

  const roomMessage = localStorage.getItem("roomMessage")

  const { data: roomsList, refetch } = useGetRoomsQuery({
    searchBar: searchRooms,
  })

  useEffect(() => {
    let timeOut = setTimeout(() => {
      refetch()
    }, 800)
    return clearTimeout(timeOut)
  }, [searchRooms])
  const [show, setShow] = useState(false)
  const [showNoDataImage, setShowNoDataImage] = useState(false)
  const handleClose = () => setShow(false)
  const handleShow = () => setShow(true)
  const [roomIndex, setRoomIndex] = useState(-1)

  const [submitForm, { isError, error, data: deleteRoomData }] =
    useDeleteRoomMutation({})

  const [updateNameForm, { data: updateRoomsData }] = useUpdateRoomNameMutation(
    {},
  )

  const [addTofavForm, { data: favRoomData }] = useAddToFavRoomMutation({})

  useEffect(() => {
    if (deleteRoomData?.message) {
      toast.success("the room has been successfully deleted")
    }
  }, [deleteRoomData])

  useEffect(() => {
    if (updateRoomsData?.message) {
      toast.success(updateRoomsData?.message, { toastId: 1 })
    }
  }, [updateRoomsData])

  useEffect(() => {
    if (favRoomData?.message) {
      dispatch(favRoom(favRoomData?.message))

      toast.success(favRoomData?.message, { toastId: 1 })
    }
  }, [favRoomData])

  const [updateId, setUpdateId] = useState("")
  const [updatedName, setUpdatedName] = useState(" ")

  const handleRoomName = () => {
    if (updatedName !== " " && updatedName !== undefined) {
      updateNameForm({
        _id: updateId,
        newRoomName: updatedName,
      })
      handleClose()
    } else {
      toast.error("Please enter Room Name")
    }
  }

  return (
    <>
      <Modal show={show} className="modal-custom" onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Rename Room</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <input
            type="text"
            onChange={(e: any) => {
              setUpdatedName(e.target.value)
            }}
          />
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          <Button
            variant="primary"
            onClick={() => {
              handleRoomName()
            }}
          >
            Save Changes
          </Button>
        </Modal.Footer>
      </Modal>
      <Container fluid>
        <section className="dashboard main-wrapper px-4">
          <Row className="">
            <Col>
              <div className="create-cardroom d-lg-flex justify-content-between align-items-center mb-4">
                <div className="roomcard-heading mb-lg-0 mb-3">
                  <h1>
                    Generated Rooms - {localStorage.getItem("GENERATIONS")}{" "}
                    Generations Left
                  </h1>{" "}
                </div>
                <button
                  className="btn btnboxicon box-with-border"
                  onClick={() => navigate("/rooms/room1")}
                >
                  <span className="iconboxadd me-2">
                    {" "}
                    <AiOutlinePlusCircle fontSize={26} />
                  </span>
                  Generate a new room
                </button>

                <br />
                {/* <div className="room-cards">
                  <Row>
                    {roomsList?.data?.map((room: any) => (
                      <RoomCard
                        image={room.generatedImageUrl}
                        name={room.roomName}
                        key={room._id}
                        dropDownOptions={[
                          {
                            function: () => {
                              setUpdateId(room._id)
                              handleShow()
                            },
                            text: "Rename Room",
                          },
                          {
                            function: () => addTofavForm({ _id: room._id }),
                            text: "Add To Favourites",
                          },
                          {
                            function: () => submitForm({ _id: room._id }),
                            text: "Delete Room",
                          },
                        ]}
                      />
                    ))}
                  </Row>
                </div> */}
              </div>
            </Col>
          </Row>
          <Row>
            {roomsList?.data ? (
              <>
                {roomsList?.data?.map((room: any, index: number) => (
                  <Col xl={3} sm={4} className="mb-4">
                    <div className="card m-0 position-relative w-100">
                      <div className="card-image">
                        <a
                          className="d-block w-100"
                          href="https://storage.googleapis.com/dara-c1b52.appspot.com/daras_ai/media/ed79a738-603b-11ee-9a2e-02420a000175/gooey.ai%20-%20photo%20Generate%20an%20image%20of%20a%20modern%20d...sense%20of%20sophistication%20and%20creativity%20theme%204k..png"
                        >
                          <img
                            src={room.generatedImageUrl}
                            alt="image"
                            style={{ objectFit: "cover" }}
                          />
                        </a>
                      </div>
                      <div className="card-text p-3 m-0">
                        <span className="date">5 days ago</span>
                        <h4>
                          {room.roomName.charAt(0).toUpperCase() +
                            room.roomName.slice(1)}
                        </h4>

                        {/* <p className="mb-0">Lorem ipsum dolor sit </p> */}
                      </div>
                      <div className="card-stats">
                        <div
                          className="stat card-stat-btn"
                          onClick={() => {
                            setUpdateId(room._id)
                            handleShow()
                          }}
                        >
                          <div className="value">
                            <LuClipboardEdit fontSize={22} />
                          </div>
                          <div className="type d-none">Rename</div>
                        </div>
                        <div
                          className="stat border card-stat-btn card-stat-btn2"
                          onClick={() => {
                            addTofavForm({ _id: room._id }), setRoomIndex(index)
                          }}
                        >
                          <div className="value">
                            <AiOutlineHeart
                              fontSize={22}
                              style={{
                                backgroundColor:
                                  room?.isFavourite === true ? "red" : "",
                              }}
                            />
                          </div>
                          <div className="type d-none">Favourite</div>
                        </div>
                        <div
                          className="stat card-stat-btn card-stat-btn3"
                          onClick={() => submitForm({ _id: room._id })}
                        >
                          <div className="value">
                            <BsTrash fontSize={22} />
                          </div>
                          <div className="type d-none">Trash</div>
                        </div>
                      </div>
                    </div>
                  </Col>
                ))}
              </>
            ) : (
              <>
                {(() => {
                  setTimeout(() => {
                    setShowNoDataImage(true)
                  }, 1000)
                  return (
                    showNoDataImage && (
                      <img
                        src={noData}
                        className="no-data-found-image"
                        alt="No data found"
                      />
                    )
                  )
                })()}
              </>
            )}
          </Row>
        </section>
      </Container>
    </>
  )
}

export default Dashboard
